export function sanitizeDecimalInput(value, maxDecimals = 2) {
  const inputValue = value == null ? "" : String(value);
  let sanitised = inputValue.replace(/[^\d.]/g, "");
  const firstDotIndex = sanitised.indexOf(".");
  
  if (firstDotIndex !== -1) {
    const whole = sanitised.slice(0, firstDotIndex);
    const decimal = sanitised
      .slice(firstDotIndex + 1)
      .replace(/\./g, "")
      .slice(0, maxDecimals);

    sanitised = `${whole}.${decimal}`;
  }

  return sanitised;
}

export function formatDecimalDisplay(value, decimals = 2) {
  if (value == null || value === "") {
    return "";
  }

  const parsed = Number(value);
  if (Number.isNaN(parsed)) {
    return "";
  }

  return parsed.toFixed(decimals);
}

export function toRoundedNumber(value, decimals = 2) {
  if (value == null || value === "") {
    return null;
  }

  const parsed = Number(value);
  if (Number.isNaN(parsed)) {
    return null;
  }

  return Number(parsed.toFixed(decimals));
}
